export const AnimationClass = {
    fadeInDown: "animate__fadeInDown",
    fadeIn: "animate__fadeIn",
}